module.exports = __webpack_public_path__ + "img/beachvolleyball.a7d4ace0.svg";